import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeFrom',
    component: () => import('../views/homeFrom.vue')
  },
  {
    path: '/about',
    name: 'about',

    component: () => import('../views/about.vue')
  },
  {
    path: '/download',
    name: 'download',

    component: () => import('../views/download.vue')
  },
  {
    path: '/myFrom',
    name: 'myFrom',

    component: () => import('../views/myFrom.vue')
  },
  {
    path: '/contact',
    name: 'contact',

    component: () => import('../views/contact.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
